import { ERegion, REGIONALIZATION, UniRegionalizationConfig } from '@constants';

import { useProfile } from '@/store';

type RegionalizationHookReturn = {
  uni: UniRegionalizationConfig;
};

export const useRegionalization = (): RegionalizationHookReturn => {
  const { profile } = useProfile();
  const region = profile?.regionConfig ?? ERegion.ES;

  return {
    uni: REGIONALIZATION.uni[region]
  };
};
